export const stringifyError = (error: Error): string => {
  return JSON.stringify({
    name: error.name,
    message: error.message,
    stack: error.stack,
  })
}
